<template>
  <div class="form-group col-12 col-w-full">
    <form action="#" @submit.prevent="inactiveDevice()">
      <div class="d-flow ml-2 mb-4">
          <h5 class="">
          Não é possível realizar pix acima de R$ 200,00 por transação ou R$ 1000,00 por dia, através de um dispositivo inativo.
          Deseja continuar?
          </h5>
      </div>
      <WhiteLabel class="mb-4 col-12">
        <button type="submit" class="btn btn-md btn-orange col-12">
          Inativar dispositivo
        </button>
        <small class="text-muted d-block mt-1">Um código de autenticação será enviado</small>
      </WhiteLabel>
    </form>
  </div>
</template>

<script>
import WhiteLabel from '@/components/shared/WhiteLabel';

export default {
  name: 'InactiveDeviceModalSection',

  components: {
    WhiteLabel,
  },
  methods: {
    inactiveDevice() {
      this.$emit('inactive-device');
    },
  },
};
</script>
